export default __webpack_public_path__ + "static/media/starearning-grap.3cd5fecb.svg";